import { loadSearchPage } from "./search.data";

export function getSearchPage({
  data,
  signal,
}: {
  data: { href: string };
  signal?: AbortSignal | undefined;
}) {
  return loadSearchPage({ ...data, signal });
}
